import { Component, Input, OnInit } from '@angular/core';
import { ChartDataSets, ChartType } from 'chart.js';
import { Color, Label } from 'ng2-charts';
import { DataCharts } from 'src/app/model/installation/charts.model';
import { InstallationsService } from 'src/app/services/http/installations/installations.service';

@Component({
  selector: 'app-installation-hourly-distribution',
  templateUrl: './installation-hourly-distribution.component.html',
  styleUrls: ['./installation-hourly-distribution.component.scss']
})
export class InstallationHourlyDistributionComponent implements OnInit {

  @Input() installation : any;

  lineChartData: ChartDataSets[] = [];

  lineChartLabels: Label[] = [];
  chartDatas: any[]=[];

  lineChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true
          }
        }
      ]
    }
  };



  lineChartColors: Color[] = [
    {
      borderColor: '#8888e8',
      backgroundColor: 'rgba(255,255,255,0.28)',
      pointBorderColor: '#5555e8',
      pointBackgroundColor: '#5555e8'
    },
  ];

  lineChartLegend = true;
  lineChartPlugins = [];
  lineChartType: ChartType = 'line';

  constructor(private service: InstallationsService) { }

  public charts !: DataCharts;


  ngOnInit(): void {


    if (this.installation) {

      this.service.getChartsData((this.installation.id_backup).toString()).subscribe((charts) => {
        this.charts = charts;

for(var i = 0;i<charts.data_chart2.length;i++){
  this.lineChartLabels[i]=charts.data_chart2[i].heure;
  this.chartDatas[i] = parseFloat(charts.data_chart2[i].ventes_count);
}
 

        this.lineChartData = [
          {
            data: this.chartDatas, label: 'Ventes (%)'
          }
        ]

        // console.log(this.chartDatas);
        // console.log(this.lineChartLabels);

      })
    }

  }

}
